import { useTranslation } from 'react-i18next';
import PublicLayout from './PublicLayout';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">{t('about.title')}</h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('about.missionTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('about.missionText')}
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('about.whatWeDoTitle')}</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              {t('about.whatWeDoText')}
            </p>
            <ul className="space-y-3">
              {[t('about.whatWeDo1'), t('about.whatWeDo2'), t('about.whatWeDo3'), t('about.whatWeDo4')].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <svg className="w-5 h-5 text-blue-600 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('about.valuesTitle')}</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                { title: t('about.value1Title'), desc: t('about.value1Desc') },
                { title: t('about.value2Title'), desc: t('about.value2Desc') },
                { title: t('about.value3Title'), desc: t('about.value3Desc') },
              ].map((value, i) => (
                <div key={i} className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{value.title}</h3>
                  <p className="text-gray-600 text-sm">{value.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('about.contactTitle')}</h2>
            <p className="text-gray-600">
              {t('about.contactText')}{' '}
              <a href="mailto:info@ai-ia.dev" className="text-blue-600 hover:underline">info@ai-ia.dev</a>
            </p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
}
